
import BounsDataTable from '../../../../Components/hr/bouns/bounsIndex/bounsDataTable'
import PageHeader from '../../../../Components/UI/PageHeader'



const Bouns = () => {
  return (
    <div>
      <PageHeader title="Bouns" showButton={true} url={`${process.env.PUBLIC_URL}/bounsstore`}/>
      <BounsDataTable/></div>
  )
}    
  
export default Bouns